import { Badge } from '@e2n/ui';
import {
  Vertrag,
  VertragStatus,
} from '@/domain/vertraege/shared/types/vertrag';
import { useTranslation } from 'react-i18next';

export function VertragsInfo({ vertrag }: { vertrag: Vertrag }) {
  const { t } = useTranslation();
  return (
    <div className="w-full flex flex-col gap-2">
      <div className="flex gap-2">
        <h5 className="font-bold">W-{vertrag.id}</h5>
        {vertrag.status !== VertragStatus.Beendet &&
        vertrag.status !== VertragStatus.Gekuendigt ? (
          <Badge className="bg-primary-green-600">
            {t('domain.vertraege.info.Aktiv').toUpperCase()}
          </Badge>
        ) : (
          <Badge className="bg-neutrals-600">
            {t('domain.vertraege.info.Inaktiv').toUpperCase()}
          </Badge>
        )}
      </div>
      <div className="flex flex-row gap-2">
        <Badge
          variant="secondary"
          className="font-semibold text-neutrals-800 bg-[#E5E7EB]">
          {'K-' + vertrag.kundennummer.toString()}
        </Badge>
        <span>{vertrag.unternehmensname}</span>
      </div>
    </div>
  );
}
